/**
 * The published agent manifest, served from Front Door at `/agent/manifest.json`.
 */
export interface AgentManifest {
  latestVersion: string;
}

/**
 * Path of the agent manifest on the Front Door endpoint.
 */
export const AGENT_MANIFEST_PATH = '/agent/manifest.json';

/**
 * Fetches the agent manifest, always revalidating with the server. The manifest changes on every
 * agent release, so a browser-cached copy (which may have been stored without cache headers and
 * reused heuristically for days) would point users at an outdated installer.
 * Returns null when the manifest cannot be retrieved.
 */
export async function fetchAgentManifest(fetchFn: typeof fetch = fetch): Promise<AgentManifest | null> {
  const response = await fetchFn(AGENT_MANIFEST_PATH, { cache: 'no-cache' });
  if (!response.ok) {
    return null;
  }
  return response.json() as Promise<AgentManifest>;
}
